import { render, staticRenderFns } from "./StudioEventsPreview.vue?vue&type=template&id=82248bd6&"
import script from "./StudioEventsPreview.vue?vue&type=script&lang=js&"
export * from "./StudioEventsPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports